export default class PermissionsUtil {
  /**
   * Les permissions de l'utilisateur sont comparés à celle demandées, return true si au moins une permission correspond
   * @param userPermissions
   * @param permissions
   * @returns {boolean}
   */
  static checkPermissions(userPermissions, permissions, title) {
    let valid = false;
    if (!userPermissions || !permissions) {
      return false;
    }
    for (let i = 0; i < permissions.length; i++) {
      const routePermission = permissions[i];
      for (let j = 0; j < userPermissions.length; j++) {
        const permission = userPermissions[j];
        if (permission.groupReference === routePermission.groupReference
          && permission.access.find(access => routePermission.access.includes(access)) !== undefined) {
          valid = true;
          break;
        }
      }
    }
    return valid;
  }
}
